import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoanDashboardComponent } from "./loan-dashboard.component";
import { AadhaarKycComponent } from "./components/aadhaar-kyc/aadhaar-kyc.component";
import { PanExpiredComponent } from "./components/pan-expired/pan-expired.component";
import { ReTakeComponent } from "./components/re-take/re-take.component";

const routes: Routes = [
    {
        path: "",
        redirectTo: "apply",
        pathMatch: "full",
    },
    {
        path: "",
        component: LoanDashboardComponent,
        children: [
            {
                path: "apply",
                loadChildren: () => import("./components/apply-loan/apply-loan.module").then((m) => m.ApplyLoanModule),
            },
            {
                path: "timeline",
                loadChildren: () => import("./components/timeline/timeline.module").then((m) => m.TimelineModule),
            },
            {
                path: "re-pay",
                loadChildren: () => import("./components/re-payment/re-payment.module").then((m) => m.RePaymentModule),
            },
            {
                path: "criteria-mismatch",
                loadChildren: () =>
                    import("./components/criteria-mismatch/criteria-mismatch.module").then(
                        (m) => m.CriteriaMismatchModule
                    ),
            },
            {
                path: "re-take",
                component: ReTakeComponent,
            },
            {
                path: "aadhaar-kyc",
                component: AadhaarKycComponent,
            },
            {
                path: "pan-expired",
                component: PanExpiredComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LoanDashboardRoutingModule {}
